/* eslint-disable jsx-a11y/img-redundant-alt */
import { Stack, Typography } from '@mui/material';

import logo from 'assets/images/logo.png';

const Logo = () => {
  return (
    <Stack direction="row" spacing={1} className="items-center">
      <img width={40} src={logo} alt="Logo image" />
      <Typography variant="h5">Biometrics</Typography>
    </Stack>
  );
};

export default Logo;
